<template>
  <div>
    <my-search
      timeScreen
      :order="1"
      :searchParams="searchParams"
      :selectArr="selectArr"
      @searchEvent="searchEvent"
    />
    <!-- 表格展示查询的数据  -->
    <myTable
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
    />
    <!-- 分页器 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
  </div>
</template>

<script>
import { pushLogList, reqSelectByType } from "@/network/autopush/pushLog";
import mixins from "@/mixins/common";
export default {
  name: "pushLog",
  mixins: [mixins],
  data() {
    return {
      UserList: [],
      tableHeader: Object.freeze([
        {
          name: "用户",
          prop: "userName",
        },
        {
          name: "文章标题",
          prop: "title",
        },
        {
          name: "任务类型",
          prop: "push",
        },
        {
          name: "任务值",
          prop: "pushType",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
      ]),
      selectArr: [
        {
          defaultText: "请选择任务类型",
          name: "type",
          getData: "value",
          defaultOptions: [],
        },
      ],
      searchParams: { type: "", timeOptions: [] },
    };
  },
  created() {
    this.getType();
  },
  methods: {
    async getType() {
      let { data } = await reqSelectByType({ type: "push_type" });
      if (data.code == 200) {
        data.data.forEach((element) => {
          this.selectArr[0].defaultOptions.push({
            value: element.value,
            label: element.name,
          });
        });
      }
    },
    getInitData(isSearch) {
      let { timeOptions, type } = this.searchParams;
      let params = {
        data: {
          value: type,
        },
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
        startTime: timeOptions ? timeOptions[0] : undefined,
        endTime: timeOptions ? timeOptions[1] : undefined,
      };
      pushLogList(params).then((e) => {
        this.loading = true;
        let { code, data } = e.data;
        if (code == 200) {
          this.loading = false;
          this.tableData = data.records;
          this.pageParams.total = data.total;
          if (isSearch) this.pageParams.currentPage = 1;
        }
      });
    },
    // 搜索
    searchEvent() {
      this.getInitData(true);
    },
  },
};
</script>

<style scoped>
</style>

 
 